import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/audit-logs';

const get = async (
	params: AuditLogs.AuditLogListParams,
): Promise<AuditLogs.AuditLogListResponse> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`${DOMAIN}?${queryParams}`);
	return data;
};

const getLatest = async (
	params: AuditLogs.AuditLogLatestParams = {},
): Promise<AuditLogs.AuditLogLatestListResponse> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`${DOMAIN}/latest?${queryParams}`);
	return data;
};

const AuditLogService = {
	get,
	getLatest,
};

export { AuditLogService };
